import { render, staticRenderFns } from "./ProductosRegistra.vue?vue&type=template&id=435404f2&"
import script from "./ProductosRegistra.vue?vue&type=script&lang=js&"
export * from "./ProductosRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports